Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLang = void 0;
var _utils = require("../../../../utils");
var useLang = exports.useLang = function useLang() {
  _utils.i18n.addResourceBundle('en', 'challengeDashboard', require("./en.json"));
};